import React, { useState } from 'react';
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer } from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from './DateRangeFilter';
import { ReportDaily } from '../../../api';
import dayjs from 'dayjs';

const DailyReport = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [rows, setRows] = useState([]);

  const run = () =>
    ReportDaily(access?.org?.id, { start, end }).then(setRows).catch(() => {});

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>Daily Report</Typography>
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run} />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Owner / Phone</TableCell>
              <TableCell>Pet</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Time In</TableCell>
              <TableCell>Acknowledged</TableCell>
              <TableCell>Checked Out</TableCell>
              <TableCell>Comment</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id}>
                <TableCell>{r.ownerName}<br /><small>{r.phone}</small></TableCell>
                <TableCell>{r.petName}</TableCell>
                <TableCell>{[r.reason?.label, r.subreason?.label].filter(Boolean).join(' / ')}</TableCell>
                <TableCell>{dayjs(r.createdAt).format('MM/DD/YY h:mm A')}</TableCell>
                <TableCell>{r.acknowledgedAt ? dayjs(r.acknowledgedAt).format('h:mm A') : '—'}</TableCell>
                <TableCell>{r.completedAt ? dayjs(r.completedAt).format('h:mm A') : '—'}</TableCell>
                <TableCell>{r.comment}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={7} align="center">No results</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DailyReport;
